import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";

import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  ThreadsIcon,
  LinkedinShareButton,
  ThreadsShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";

interface ShareSpaceType {
  show: boolean;
  closeModal: Function;
  name: string;
  title: string;
  content: string;
  url: string;
}

const ShareSpaceModal: React.FC<ShareSpaceType> = ({
  show,
  closeModal,
  name,
  title,
  content,
  url,
}) => {
  const [spaceTitle, setSpaceTitle] = useState("");
  const [spaceContent, setSpaceContent] = useState("");
  const [spaceUrl, setSpaceUrl] = useState("");

  useEffect(() => {
    setSpaceTitle(title);
    setSpaceContent(content);
    setSpaceUrl(url);
  });

  console.log("spaceContent :", spaceContent, content);

  const hashtags = ["React", "WebDev", "JavaScript"];

  return (
    <Modal show={show} onHide={() => closeModal()}>
      <Modal.Header closeButton>Share {name}</Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <input
            type="text"
            name="title"
            value={spaceTitle}
            onChange={(e) => setSpaceTitle(e.target.value)}
            className="form-control"
          />
        </div>

        <div className="form-group">
          <textarea
            className="form-control"
            rows={4}
            value={spaceContent}
          ></textarea>
        </div>

        <div className="social-icons-wrapper">
          {/* Facebook */}
          <FacebookShareButton
            url={spaceUrl}
            title={spaceTitle}
            content={`${spaceTitle} — ${spaceContent}`}
          >
            <FacebookIcon size={40} round />
          </FacebookShareButton>

          {/* Threads */}
          <ThreadsShareButton
            url={spaceUrl}
            // title={spaceTitle}
            title={`${spaceTitle} — ${spaceContent}`}
          >
            <ThreadsIcon size={40} round />
          </ThreadsShareButton>
          {/* LinkedIn */}
          <LinkedinShareButton
            url={spaceUrl}
            title={spaceTitle}
            summary={spaceContent}
            source={spaceUrl}
          >
            <LinkedinIcon size={40} round />
          </LinkedinShareButton>

          {/* X / Twitter */}
          <TwitterShareButton
            url={spaceUrl}
            title={`${spaceTitle} — ${spaceContent}`}
            hashtags={hashtags}
          >
            <TwitterIcon size={40} round />
          </TwitterShareButton>

          {/* WhatsApp */}
          <WhatsappShareButton
            url={spaceUrl}
            title={`${spaceTitle} — ${spaceContent}`}
            separator="  "
          >
            <WhatsappIcon size={40} round />
          </WhatsappShareButton>

          {/* Email */}
          <EmailShareButton
            url={spaceUrl}
            subject={spaceTitle}
            body={`${spaceContent}\n\nRead more here: ${spaceUrl}`}
          >
            <EmailIcon size={40} round />
          </EmailShareButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShareSpaceModal;
